import { forwardRef, type SVGProps } from 'react';

export const DataExchangeTestDataIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(function DataExchangeTestDataIcon(props, ref) {
  return (
    <svg
      ref={ref}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21 9L17 5V8H10V10H17V13M7 11L3 15L7 19V16H14V14H7V11Z"
        fill="currentColor"
      />
    </svg>
  );
});
